import { actions } from 'react-redux-form';

import { httpGet } from '../../../../utils/api.utils';
import {
    accessInformationFormModel,
    getCircuitAccessInformationDetails,
    getAccessBandwidth,
    getElectricalOpticalInterface,
    getServiceClass,
    setAccessBandwidthLoading,
    setElectricalOpticalInterfaceLoading,
    setServiceClassLoading,
} from "../../../../constants/model-reducers/external/inventory/circuit-details/details-view/access-information.settings";

const defaultState = () => ({
    accessOptions: [],
    accessBandwidthOptions: [],
    electircalOpticalInterfaceOptions: [],
    serviceClassOptions: [],
    siteSurveyRequestedOptions: [],
    existingCircuitIDOptions: [],
    isCoordinatedServiceOptions: [],
    requiredLOACFAOptions: [],
    accessBandwidthPage: 1,
    hasMoreAccessBandwidth: true,
    isAccessBandwidthLoading: false,
    electricalOpticalInterfacePage: 1,
    hasMoreElectricalOpticalInterface: true,
    isElectricalOpticalInterfaceLoading: false,
    serviceClassPage: 1,
    hasMoreServiceClass: true,
    isServiceClassLoading: false,
});
const initialState = defaultState();

export const accessInformationFormInitialState = accessInformationFormModel;

export const accessInformationActions = {
    getCircuitAccessInformationDetails: (model, circuitID) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getCircuitAccessInformationItemDetails/' + circuitID);
        await dispatch(accessInformationActions.getAccessBandwidth(1, res?.data?.AccessBandwidth !== null ? res?.data?.AccessBandwidthName : ""));
        await dispatch(accessInformationActions.getElectricalOpticalInterface(1, res?.data?.ElectricalOpticalInterface !== null ? res?.data?.ElectricalOpticalInterfaceName : ""));
        await dispatch(accessInformationActions.getServiceClass(1, res?.data?.ServiceClass !== null ? res?.data?.ServiceClassName : ""));
        dispatch({
            type: getCircuitAccessInformationDetails,
            accessOptions: res.accessOptions,
            siteSurveyRequestedOptions: res.siteSurveyRequestedOptions,
            existingCircuitIDOptions: res.existingCircuitIDOptions,
            isCoordinatedServiceOptions: res.isCoordinatedServiceOptions,
            requiredLOACFAOptions: res.requiredLOACFAOptions,
        });

        if (res.data != null && circuitID !== 0) {
            dispatch(actions.change(`${model}.siteSurveyRequested`, res.data.SiteSurveyRequested ?? ""));
            dispatch(actions.change(`${model}.accessBandwidth`, res.data.AccessBandwidth !== null ? res.data.AccessBandwidth.toString() : ""));
            dispatch(actions.change(`${model}.access`, res.data.Access ?? ""));
            dispatch(actions.change(`${model}.existingCircuitID`, res.data.ExistingCircuitID ?? ""));
            dispatch(actions.change(`${model}.isCoordinatedService`, res.data.CoordinatedService ?? ""));
            dispatch(actions.change(`${model}.electricalOpticalInterface`, res.data.ElectricalOpticalInterface !== null ? res.data.ElectricalOpticalInterface.toString() : ""));
            dispatch(actions.change(`${model}.requiredLOACFA`, res.data.LOA_CFA_Required ?? ""));
            dispatch(actions.change(`${model}.accessPortCIR`, res.data.Access_Port_CIR ?? ""));
            dispatch(actions.change(`${model}.DLCI`, res.data.DLCI ?? ""));
            dispatch(actions.change(`${model}.serviceClass`, res.data.ServiceClass !== null ? res.data.ServiceClass.toString() : ""));
            dispatch(actions.change(`${model}.uploadSpeed`, res.data.UploadSpeed ?? ""));
            dispatch(actions.change(`${model}.downloadSpeed`, res.data.DownloadSpeed ?? ""));
            dispatch(actions.change(`${model}.requestedIP`, res.data.RequestedIP ?? ""));
            dispatch(actions.change(`${model}.handsOffType`, res.data.HandsOffType ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.siteSurveyRequested', res.data.SiteSurveyRequested ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.accessBandwidth', res.data.AccessBandwidth !== null ? res.data.AccessBandwidth.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.access', res.data.Access ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.existingCircuitID', res.data.ExistingCircuitID ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.isCoordinatedService', res.data.CoordinatedService ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.electricalOpticalInterface', res.data.ElectricalOpticalInterface !== null ? res.data.ElectricalOpticalInterface.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.requiredLOACFA', res.data.LOA_CFA_Required ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.accessPortCIR', res.data.Access_Port_CIR ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.DLCI', res.data.DLCI ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.serviceClass', res.data.ServiceClass !== null ? res.data.ServiceClass.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.uploadSpeed', res.data.UploadSpeed ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.downloadSpeed', res.data.DownloadSpeed ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.requestedIP', res.data.RequestedIP ?? ""));
            dispatch(actions.load('inventoryCircuitForm.accessInformation.handsOffType', res.data.HandsOffType ?? ""));
        }
        else {
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.siteSurveyRequested'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.accessBandwidth'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.access'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.existingCircuitID'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.isCoordinatedService'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.electricalOpticalInterface'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.requiredLOACFA'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.accessPortCIR'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.DLCI'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.serviceClass'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.uploadSpeed'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.downloadSpeed'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.requestedIP'));
            dispatch(actions.reset('inventoryCircuitForm.accessInformation.handsOffType'));

        }
    },
    changeFormModel: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value ?? ""));
    },

    getOrderCircuitAccessInformationDetails: (model, orderId, requestTypeId, orderCircuitDetailId = 0) => async (dispatch, state) => {
        var res = await httpGet('external/order/getOrderCircuitAccessInformationDetails/' + orderId + '/' + requestTypeId + '/' + orderCircuitDetailId);
        await dispatch(accessInformationActions.getAccessBandwidth(1, res?.data?.AccessBandwidth !== null ? res?.data?.AccessBandwidthName : ""));
        await dispatch(accessInformationActions.getElectricalOpticalInterface(1, res?.data?.ElectricalOpticalInterface !== null ? res?.data?.ElectricalOpticalInterfaceName : ""));
        await dispatch(accessInformationActions.getServiceClass(1, res?.data?.ServiceClass !== null ? res?.data?.ServiceClassName : ""));
        dispatch({
            type: getCircuitAccessInformationDetails,
            accessOptions: res.accessOptions,
            siteSurveyRequestedOptions: res.siteSurveyRequestedOptions,
            existingCircuitIDOptions: res.existingCircuitIDOptions,
            isCoordinatedServiceOptions: res.isCoordinatedServiceOptions,
            requiredLOACFAOptions: res.requiredLOACFAOptions,
        });

        if (res.data != null) {
            dispatch(actions.change(`${model}.siteSurveyRequested`, res.data.SiteSurveyRequested ?? ""));
            dispatch(actions.change(`${model}.accessBandwidth`, res.data.AccessBandwidth !== null ? res.data.AccessBandwidth.toString() : ""));
            dispatch(actions.change(`${model}.access`, res.data.Access ?? ""));
            dispatch(actions.change(`${model}.existingCircuitID`, res.data.ExistingCircuitID ?? ""));
            dispatch(actions.change(`${model}.isCoordinatedService`, res.data.CoordinatedService ?? ""));
            dispatch(actions.change(`${model}.electricalOpticalInterface`, res.data.ElectricalOpticalInterface !== null ? res.data.ElectricalOpticalInterface.toString() : ""));
            dispatch(actions.change(`${model}.requiredLOACFA`, res.data.LOA_CFA_Required ?? ""));
            dispatch(actions.change(`${model}.accessPortCIR`, res.data.Access_Port_CIR ?? ""));
            dispatch(actions.change(`${model}.DLCI`, res.data.DLCI ?? ""));
            dispatch(actions.change(`${model}.serviceClass`, res.data.ServiceClass !== null ? res.data.ServiceClass.toString() : ""));
            dispatch(actions.change(`${model}.uploadSpeed`, res.data.UploadSpeed ?? ""));
            dispatch(actions.change(`${model}.downloadSpeed`, res.data.DownloadSpeed ?? ""));
            dispatch(actions.change(`${model}.requestedIP`, res.data.RequestedIP ?? ""));
            dispatch(actions.change(`${model}.handsOffType`, res.data.HandsOffType ?? ""));
        }
    },

    getAccessBandwidth: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setAccessBandwidthLoading,
            payload: true
        });

        let url = `external/inventory/getAccessBandwidth/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getAccessBandwidth,
                    payload: {
                        accessBandwidth: res,
                        accessBandwidthPage: page
                    }
                });
                dispatch({
                    type: setAccessBandwidthLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setAccessBandwidthLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setAccessBandwidthLoading,
                payload: false
            });
        }
    },

    getElectricalOpticalInterface: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setElectricalOpticalInterfaceLoading,
            payload: true
        });

        let url = `external/inventory/getElectricalOpticalInterface/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getElectricalOpticalInterface,
                    payload: {
                        electricalOpticalInterface: res,
                        electricalOpticalInterfacePage: page
                    }
                });
                dispatch({
                    type: setElectricalOpticalInterfaceLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setElectricalOpticalInterfaceLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setElectricalOpticalInterfaceLoading,
                payload: false
            });
        }
    },

    getServiceClass: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setServiceClassLoading,
            payload: true
        });

        let url = `external/inventory/getServiceClass/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getServiceClass,
                    payload: {
                        serviceClass: res,
                        serviceClassPage: page
                    }
                });
                dispatch({
                    type: setServiceClassLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setServiceClassLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setServiceClassLoading,
                payload: false
            });
        }
    },

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getCircuitAccessInformationDetails:
            return {
                ...state,
                accessOptions: action.accessOptions,
                siteSurveyRequestedOptions: action.siteSurveyRequestedOptions,
                existingCircuitIDOptions: action.existingCircuitIDOptions,
                isCoordinatedServiceOptions: action.isCoordinatedServiceOptions,
                requiredLOACFAOptions: action.requiredLOACFAOptions,
            };
        case getAccessBandwidth:
            const { accessBandwidth, accessBandwidthPage } = action.payload;
            return {
                ...state,
                accessBandwidthOptions: accessBandwidthPage === 1 ? accessBandwidth : [...state.accessBandwidthOptions, ...accessBandwidth],
                hasMoreAccessBandwidth: accessBandwidth.length > 0,
                accessBandwidthPage: accessBandwidthPage
            };
        case setAccessBandwidthLoading:
            return {
                ...state,
                isAccessBandwidthLoading: action.payload
            }
        case getElectricalOpticalInterface:
            const { electricalOpticalInterface, electricalOpticalInterfacePage } = action.payload;
            return {
                ...state,
                electircalOpticalInterfaceOptions: electricalOpticalInterfacePage === 1 ? electricalOpticalInterface : [...state.electircalOpticalInterfaceOptions, ...electricalOpticalInterface],
                hasMoreElectricalOpticalInterface: electricalOpticalInterface.length > 0,
                electricalOpticalInterfacePage: electricalOpticalInterfacePage
            };
        case setElectricalOpticalInterfaceLoading:
            return {
                ...state,
                isElectricalOpticalInterfaceLoading: action.payload
            }
        case getServiceClass:
            const { serviceClass, serviceClassPage } = action.payload;
            return {
                ...state,
                serviceClassOptions: serviceClassPage === 1 ? serviceClass : [...state.serviceClassOptions, ...serviceClass],
                hasMoreServiceClass: serviceClass.length > 0,
                serviceClassPage: serviceClassPage
            };
        case setServiceClassLoading:
            return {
                ...state,
                isServiceClassLoading: action.payload
            }
        default:
            return state;
    }
}